var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrengthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 12.447,
    viewBox: "0 0 21 12.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3168",
    "data-name": "Group 3168",
    transform: "translate(0.501 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2807",
    "data-name": "Rectangle 2807",
    width: 2.279,
    height: 11.447,
    transform: "translate(4.01 0)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2809",
    "data-name": "Rectangle 2809",
    width: 7.42,
    height: 2.362,
    transform: "translate(6.289 4.543)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2810",
    "data-name": "Rectangle 2810",
    width: 2.279,
    height: 2.362,
    transform: "translate(17.72 4.543)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2812",
    "data-name": "Rectangle 2812",
    width: 1.732,
    height: 7.331,
    transform: "translate(15.988 2.058)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2813",
    "data-name": "Rectangle 2813",
    width: 2.279,
    height: 2.362,
    transform: "translate(-0.001 4.543)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2815",
    "data-name": "Rectangle 2815",
    width: 1.732,
    height: 7.331,
    transform: "translate(2.278 2.058)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2816",
    "data-name": "Rectangle 2816",
    width: 2.279,
    height: 11.447,
    transform: "translate(13.709 0)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthIcon);
export default __webpack_public_path__ + "static/media/StrengthIcon.81418a05a5ddb6bd1160063e00e5e162.svg";
export { ForwardRef as ReactComponent };